import { marked } from "marked";
import DOMPurify from "dompurify";

// Markdown -> HTML via marked, then sanitized with DOMPurify before injection.
// This strips <script>, event handlers and javascript: URLs (XSS protection),
// which matters because note content can come from imported .md files.
export function Markdown({ content, className = "" }) {
  const html = DOMPurify.sanitize(marked.parse(content || "", { async: false }));
  return (
    <div
      className={`md-preview ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
      data-testid="markdown-preview"
    />
  );
}
